<template>
  <img
    class="picture"
    :src="image.imageUri"
    :alt="image.accessibilityText"
    v-bind:class = "image.from === 'me' ? 'me' : ''"
  />
</template>

<style lang="sass" scoped>
@media only screen and (min-width: 601px)
  .picture
    margin-top: 10px
    max-width: 90%
    height: 18rem
    border-radius: 12px
    box-shadow: 0 2px 6px 2px rgba(60,64,67,0.15)
    object-fit: cover
@media only screen and (max-width: 600px)
  .picture
    margin-top: 8px
    height: 12rem
    border-radius: 8px
    box-shadow: 0 2px 6px 2px rgba(60,64,67,0.15)
    object-fit: fill
</style>

<script>
export default {
  name: "Picture",
  props: ["image"]
};
</script>
